// ownStrokeActivity — 自分が stroke.start を送った回数 (このページの生存中の通算)。
//
// 「新機能の紹介」の入室時自動表示 (useWhatsNewEntryAutoOpen) が「入室から判断までの間に
// 本人が描き始めたか」を見るために使う。描画中 (ペンが下りている) も stroke.start 済みなので
// 回数の増加だけで足りる。sendStrokeStart (useCases) が 1 か所で数える。

let startedCount = 0;

export const noteOwnStrokeStart = (): void => {
  startedCount += 1;
};

export const getOwnStrokeStartedCount = (): number => startedCount;
